import { Divider } from "@msuite/ui/divider";
import React from "react";
import { VehicleFormCrane } from "./vehicle-form-crane";

export function VehicleFormCranes() {
	/** Render */
	return (
		<React.Fragment>
			<VehicleFormCrane position="front" />
			<Divider
				variant="content-card"
				className="my-4"
			/>
			<VehicleFormCrane position="tail" />
		</React.Fragment>
	);
}
